var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monitor 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2083 4.58341V5.00008C15.2083 5.01425 15.2091 5.02841 15.21 5.04258V5.04841L15.2116 5.06425L15.2125 5.07175C15.2266 5.21925 15.2841 5.32758 15.3591 5.40675C15.4733 5.54008 15.6433 5.62508 15.8333 5.62508C15.8333 5.62508 16.4583 5.58091 16.4583 4.99508V4.58341C16.4583 3.97591 16.2166 3.39258 15.7875 2.96258C15.3575 2.53341 14.7741 2.29175 14.1666 2.29175C11.4408 2.29175 6.05913 2.29175 3.33329 2.29175C2.72579 2.29175 2.14246 2.53341 1.71246 2.96258C1.28329 3.39258 1.04163 3.97591 1.04163 4.58341V12.0834C1.04163 12.6909 1.28329 13.2742 1.71246 13.7042C2.14246 14.1334 2.72579 14.3751 3.33329 14.3751H9.58329C9.92829 14.3751 10.2083 14.0951 10.2083 13.7501C10.2083 13.4051 9.92829 13.1251 9.58329 13.1251C9.58329 13.1251 5.65579 13.1251 3.33329 13.1251C3.05663 13.1251 2.79246 13.0151 2.59663 12.8201C2.40163 12.6242 2.29163 12.3601 2.29163 12.0834C2.29163 10.0467 2.29163 6.62008 2.29163 4.58341C2.29163 4.30675 2.40163 4.04258 2.59663 3.84675C2.79246 3.65175 3.05663 3.54175 3.33329 3.54175H14.1666C14.4433 3.54175 14.7075 3.65175 14.9033 3.84675C15.0983 4.04258 15.2083 4.30675 15.2083 4.58341Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0725 16.4585H4.92664C4.58247 16.4585 4.30247 16.7385 4.30164 17.0835C4.30164 17.4285 4.58247 17.7085 4.92664 17.7085H10.0733C10.4175 17.7085 10.6983 17.4285 10.6983 17.0835C10.6975 16.7385 10.4175 16.4585 10.0725 16.4585Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9583 8.75016C18.9583 7.48433 17.9325 6.4585 16.6666 6.4585C15.6608 6.4585 14.3833 6.4585 13.3775 6.4585C12.1125 6.4585 11.0858 7.48433 11.0858 8.75016V15.4168C11.0858 16.6827 12.1125 17.7085 13.3775 17.7085H16.6666C17.9325 17.7085 18.9583 16.6827 18.9583 15.4168V8.75016ZM17.7083 8.75016V15.4168C17.7083 15.9918 17.2416 16.4585 16.6666 16.4585C15.6608 16.4585 14.3833 16.4585 13.3775 16.4585C12.8025 16.4585 12.3358 15.9918 12.3358 15.4168V8.75016C12.3358 8.17516 12.8025 7.7085 13.3775 7.7085H16.6666C17.2416 7.7085 17.7083 8.17516 17.7083 8.75016Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitor);
export default __webpack_public_path__ + "static/media/monitor.43c4964a0c7e53a272b5e3bad06fe19a.svg";
export { ForwardRef as ReactComponent };